const EN_US = {
  'campaigns.create.customCampaign.title': 'Create a custom campaign',
  'campaigns.create.customCampaign.breadcrumb1': 'Campaign',
  'campaigns.create.customCampaign.breadcrumb2': 'Create campaign',
  'campaigns.create.customCampaign.form.header': 'Create campaign',
  'campaigns.create.customCampaign.form.section.name.heading': 'Name',
  'campaigns.create.customCampaign.form.section.name.description':
    'This name is used to track your campaign.',
  'campaigns.create.customCampaign.form.section.name.placeholder': 'Enter a campaign name',
  'campaigns.create.customCampaign.form.section.placement.heading': 'Placement',
  'campaigns.create.customCampaign.form.section.placement.page.heading': 'Host page',
  'campaigns.create.customCampaign.form.section.placement.page.description': 'Homepage',
  'campaigns.create.customCampaign.form.section.placement.placementType.heading': 'Placement type',
  'campaigns.create.customCampaign.form.section.placement.placementType.description':
    'Primary banner carousel',
  'campaigns.create.customCampaign.form.section.placement.carouselDetails.heading':
    'Banner carousel details',
  'campaigns.create.customCampaign.form.section.placement.carouselDetails.description':
    '{numberOfBanners} banners occupied',
  'campaigns.create.customCampaign.form.section.placement.rank.heading':
    'Choose where to insert your banner',
  'campaigns.create.customCampaign.form.section.placement.rank.firstLabel': 'Insert as first',
  'campaigns.create.customCampaign.form.section.placement.rank.lastLabel': 'Insert as last',
  'campaigns.create.customCampaign.form.section.placement.rank.footnote':
    'Inserts the banner as the first slot in the carousel and bumps the existing banners down.',
  'campaigns.create.customCampaign.form.section.duration.heading': 'Duration',
  'campaigns.create.customCampaign.form.section.duration.description':
    'Choose how long this campaign will appear.',
  'campaigns.create.customCampaign.form.section.duration.radio.ongoing.label': 'Ongoing',
  'campaigns.create.customCampaign.form.section.duration.radio.range.label': 'Select a date range',
  'campaigns.create.customCampaign.form.section.duration.checkbox.noEndDate.label': 'No end date',
  'campaigns.create.customCampaign.form.summary.sectionTitle': 'Summary',
  'campaigns.create.customCampaign.form.summary.field.name.label': 'Name',
  'campaigns.create.customCampaign.form.summary.field.name.placeholder': 'No name',
  'campaigns.create.customCampaign.form.summary.field.destination.label': 'Destination',
  'campaigns.create.customCampaign.form.summary.field.destination.placeholder': 'No destination',
  'campaigns.create.customCampaign.form.summary.field.placement.label': 'Placement',
  'campaigns.create.customCampaign.form.summary.field.placement.placeholder': 'No placement',
  'campaigns.create.customCampaign.form.summary.field.duration.label': 'Duration',
  'campaigns.create.customCampaign.form.summary.field.duration.value.ongoing': 'Ongoing',
  'campaigns.create.customCampaign.form.summary.field.duration.value.noEndDate': 'No end date',
  'campaigns.create.customCampaign.form.summary.field.duration.value.noStartDate': 'No start date',
  'retailerFundedMarketingDomain.lastUpdatedEveryHour.tooltip': 'The data is updated every hour',
  'retailerFundedMarketingDomain.filters.campaignName': 'Campaigns',
  'retailerFundedMarketingDomain.create.title': 'Campaigns',
  'retailerFundedMarketingDomain.create.cancelButton': 'Cancel',
  'retailerFundedMarketingDomain.create.activateButton': 'Activate',
  'retailerFundedMarketingDomain.create.saveButton': 'Save',
  'retailerFundedMarketingDomain.create.saveDraftButton': 'Save Draft',
  'retailerFundedMarketingDomain.campaignDetailsHeader.newCustomerDiscount.label':
    'Acquire new customers',
  'retailerFundedMarketingDomain.campaignDetailsHeader.newCustomerDiscount.description':
    'Acquire new customers by offering a discount on their first order.',
  'retailerFundedMarketingDomain.campaignDetailsField.name.label': 'Name',
  'retailerFundedMarketingDomain.campaignDetailsField.name.placeholder': 'Enter a campaign name',
  'retailerFundedMarketingDomain.campaignDetailsField.channel.label': 'Channel',
  'retailerFundedMarketingDomain.campaignDetailsField.channel.description': 'On Marketplace',
  'retailerFundedMarketingDomain.campaignDetailsField.audience.label': 'Audience',
  'retailerFundedMarketingDomain.campaignDetailsField.audience.description':
    'New Customer, All Locations (35)',
  'retailerFundedMarketingDomain.campaignDetailsField.offer.label': 'Offer',
  'retailerFundedMarketingDomain.campaignDetailsField.offer.description':
    '$5 off for orders $50 or more',
  'retailerFundedMarketingDomain.campaignDetailsField.duration.label': 'Duration',
  'retailerFundedMarketingDomain.campaignDetailsField.duration.description':
    'Starts 10/01/2020, Ends 10/31/2020',
  'retailerFundedMarketingDomain.campaignDetailsField.editButton': 'Edit',
  'retailerFundedMarketingDomain.title': 'Retailer Funded Marketing',
  'retailerFundedMarketingDomain.listCampaign.title': 'Campaigns',
  'retailerFundedMarketingDomain.listCampaign.created': 'Campaign activated successfully!',
  'retailerFundedMarketingDomain.listCampaign.viewCampaign': 'View Campaign',
  'retailerFundedMarketingDomain.performance': 'Performance',
  'retailerFundedMarketingDomain.rfmCampaignDashboard.metrics.spend': 'Spend',
  'retailerFundedMarketingDomain.rfmCampaignDashboard.metrics.redemptions': 'Redemptions',
  'retailerFundedMarketingDomain.rfmCampaignDashboard.metrics.attributedSales': 'Attributed sales',
  'retailerFundedMarketingDomain.rfmCampaignDashoard.metrics.roas': 'ROI',
  'retailerFundedMarketingDomain.rfmCampaignDashboard.table.title': 'Campaign details',
  'retailerFundedMarketingDomain.rfmCampaignDashboard.table.header.campaignName': 'Campaign Name',
  'retailerFundedMarketingDomain.rfmCampaignDashboard.table.header.campaignStatus': 'Status',
  'retailerFundedMarketingDomain.rfmCampaignDashboard.table.header.start': 'Start',
  'retailerFundedMarketingDomain.rfmCampaignDashboard.table.header.end': 'End',
  'retailerFundedMarketingDomain.rfmCampaignDashboard.table.header.budget': 'Total budget',
  'retailerFundedMarketingDomain.rfmCampaignDashboard.table.header.spend': 'Spend',
  'retailerFundedMarketingDomain.rfmCampaignDashboard.table.header.redemption': 'Redemption',
  'retailerFundedMarketingDomain.rfmCampaignDashboard.table.header.attGmv': 'Attributed GMV',
  'retailerFundedMarketingDomain.rfmCampaignDashboard.table.header.roas': 'ROI',
  'retailerFundedMarketingDomain.rfmCampaignDashboard.table.header.avgDailySpend':
    'Avg. Daily Spend',
  'retailerFundedMarketingDomain.rfmCampaignDashboard.table.header.applications': 'Applications',
  'retailerFundedMarketingDomain.rfmCampaignDashboard.table.header.redemptionRate':
    'Redemption Rate',
  'retailerFundedMarketingDomain.rfmCampaignDashboard.table.header.activations': 'Activations',
  'retailerFundedMarketingDomain.rfmCampaignDashboard.table.header.costPerActivation':
    'Cost per activation',
  'retailerFundedMarketingDomain.rfmCampaignDashboard.table.header.outstandingOrders':
    'Outstanding Orders',
  'retailerFundedMarketingDomain.rfmCampaignDashboard.table.header.outstandingSpend':
    'Outstanding Spend',
  'retailerFundedMarketingDomain.rfmCampaignDashboard.table.newCampaigns':
    'Newly active campaigns will take over an hour to display performance data. Thanks for your patience.',
  'retailerFundedMarketingDomain.rfmCampaignDashboard.table.view': 'View',
  'retailerFundedMarketingDomain.rfmCampaignDashboard.table.export': 'Export',
  'retailerFundedMarketingDomain.rfmCampaignDashboard.table.cancel': 'Cancel',
  'retailerFundedMarketingDomain.rfmCampaignDashboard.table.downloadFileName':
    'Campaign performance data',
  'retailerFundedMarketingDomain.createCampaignModal.title': 'Create',
  'retailerFundedMarketingDomain.createCampaignModal.newCustomers.title': 'Acquire new customers',
  'retailerFundedMarketingDomain.createCampaignModal.newCustomers.subtitle':
    'Acquire new customers by offering a discount on their first order.',
  'retailerFundedMarketingDomain.createCampaignModal.newCustomers.targetDomain': 'On Marketplace',
  'retailerFundedMarketingDomain.createCampaignModal.customCampaign.title':
    'Create a custom campaign',
  'retailerFundedMarketingDomain.createCampaignModal.customCampaign.subtitle':
    'Have it your way. Create a campaign from scratch.',
  'retailerFundedMarketingDomain.createCampaignModal.customCampaign.targetDomain':
    'On Storefront Pro',
  'retailerFundedMarketingDomain.createCampaignModal.disclaimer1': 'Additional campaigns to come',
  'retailerFundedMarketingDomain.createCampaignModal.disclaimer2':
    'We will continue to build out more campaign templates as well as custom campaign functionality. To support development, connect with your Instacart Admin to share your unique campaign use cases.',
  'retailerFundedMarketingDomain.dollarAmountDiscount.percentageLow.alert.message':
    'You are unable to offer a discount for less than 5% off',
  'retailerFundedMarketingDomain.dollarAmountDiscount.percentageHigh.alert.message':
    'You are unable to offer a discount for greater than 100% off',
  'retailerFundedMarketingDomain.dollarAmountDiscount.title': 'Dollar amount discount',
  'retailerFundedMarketingDomain.dollarAmountDiscount.minimumPurchaseAmount.title':
    'Minimum purchase amount ($)',
  'retailerFundedMarketingDomain.dollarAmountDiscount.maximumUses.title': 'Maximum Uses',
  'retailerFundedMarketingDomain.dollarAmountDiscount.discoverability.title': 'Discoverability',
  'retailerFundedMarketingDomain.dollarAmountDiscount.discoverability.description':
    'Is this discoverable in the store, or is this hidden and used for a mechandised landing page such as QR code onboarding',
  'retailerFundedMarketingDomain.dollarAmountDiscount.validForDays.title':
    'Coupon Duration (Suggested: 7 days)',
  'retailerFundedMarketingDomain.dollarAmountDiscount.validForDays.description':
    'How long the coupon will be valid for the Customer from the time of their clipping',
  'retailerFundedMarketingDomain.dollarAmountDiscount.validForDays.errorMessage':
    'Please select a number in the range of 1 and 30',
  'retailerFundedMarketingDomain.dollarAmountDiscount.summary.title': 'Summary',
  'retailerFundedMarketingDomain.EditAudienceModal.customers': 'Customers',
  'retailerFundedMarketingDomain.EditAudienceModal.locations': 'Locations',
  'retailerFundedMarketingDomain.EditAudienceModal.title': 'New Customers',
  'retailerFundedMarketingDomain.EditAudienceModal.save': 'Save',
  'retailerFundedMarketingDomain.EditAudienceModal.cancel': 'Cancel',
  'retailerFundedMarketingDomain.EditAudienceModal.clearAll': 'Clear All',
  'retailerFundedMarketingDomain.EditAudienceModal.audienceTitle': 'Audience',
  'retailerFundedMarketingDomain.EditAudienceModal.subtitle':
    "Only customers who haven't ordered from you before.",
  'retailerFundedMarketingDomain.EditAudienceModal.selectLocations': 'Select Locations',
  'retailerFundedMarketingDomain.cancelCampaignModal.title': 'Confirm campaign cancellation',
  'retailerFundedMarketingDomain.cancelCampaignModal.message1': 'Are you sure you want to cancel',
  'retailerFundedMarketingDomain.cancelCampaignModal.message2':
    "You won't be able to restore this campaign or export its data later.",
  'retailerFundedMarketingDomain.cancelCampaignModal.confirm': 'Confirm',
  'retailerFundedMarketingDomain.getCampaignPage.cancel': 'Cancel',
  'retailerFundedMarketingDomain.getCampaignPage.campaigns': 'Campaigns',
  'retailerFundedMarketingDomain.getCampaignPage.editCampaign': 'Edit Campaign',
  'retailerFundedMarketingDomain.editDurationModal.activeDates': 'Active dates',
  'retailerFundedMarketingDomain.editDurationModal.startDate': 'Start date',
  'retailerFundedMarketingDomain.editDurationModal.startTime': 'Start time',
  'retailerFundedMarketingDomain.editDurationModal.setEndDate': 'Set End date',
  'retailerFundedMarketingDomain.editDurationModal.endDate': 'End date',
  'retailerFundedMarketingDomain.editDurationModal.endTime': 'End Time',
  'retailerFundedMarketingDomain.editDurationModal.timezone': 'Timezone',
  'retailerFundedMarketingDomain.editDurationModal.setEndDateMessage':
    'Setting an end date could reduce the amount its potential revenue. Consider letting it run.',
  'retailerFundedMarketingDomain.campaigns.nav': 'Campaigns',
  'retailerFundedMarketingDomain.campaigns.phaseFour.nav': 'Campaigns',
  'retailerFundedMarketingDomain.billingOption.title': 'Adjust billing (Admin Only)',
  'retailerFundedMarketingDomain.billingOption.fullyInstacartFunded': 'Fully Instacart funded',
  'retailerFundedMarketingDomain.billingOption.fullyInstacartFunded.description':
    '100% funded by Instacart',
  'retailerFundedMarketingDomain.billingOption.fullyRetailerFunded': 'Fully retailer funded',
  'retailerFundedMarketingDomain.billingOption.fullyRetailerFunded.description':
    '100% funded by retailer/partner',
  'retailerFundedMarketingDomain.billingOption.fiftyfifty': '50/50 funded',
  'retailerFundedMarketingDomain.billingOption.fiftyfifty.description':
    '50% funded by retailer/partner / 50% funded by Instacart',
  'retailerFundedMarketingDomain.billingOption.retailerFundedNewCustomer':
    'Retailer funded - New customers only',
  'retailerFundedMarketingDomain.billingOption.retailerFundedNewCustomer.description':
    'Only new customers are funded by retailer/partner',
  'retailerFundedMarketingDomain.billingOption.retailerFundedExistingCustomer':
    'Retailer funded - Existing customers only',
  'retailerFundedMarketingDomain.billingOption.retailerFundedExistingCustomer.description':
    'Only existing customers are funded by retailer/partner',
  'retailerFundedMarketingDomain.edit.saveButton': 'Save',
  'retailerFundedMarketingDomain.campaignDetailsField.required.error': 'This field is required',
  'retailerFundedMarketingDomain.dollarAmountDiscount.helperContent.alert.title':
    'Not sure how much to discount?',
  'retailerFundedMarketingDomain.dollarAmountDiscount.helperContent.alert.message':
    '5-30% off is the sweet spot for attracting wonderfully hungry customers.',
  'retailerFundedMarketingDomain.dollarAmountDiscount.percentage.alert.title': "We're sorry.",
  'retailerFundedMarketingDomain.campaignDetailsField.viewButton': 'View',
  'retailerFundedMarketingDomain.campaignDetailsField.locations': 'Locations',
  'retailerFundedMarketingDomain.campaignDetailsField.all.locations': 'All Locations',
  'retailerFundedMarketingDomain.campaignDetailsField.no.locations': 'No Locations',
  'retailerFundedMarketingDomain.campaignDetailsField.new.customers': 'New Customers',
  'campaigns.templates.breadcrumb.create': 'Create',
  'campaigns.templates.title': 'Campaign Templates',
  'campaigns.templates.pageHeader': 'Grow your business with our campaign templates',
  'campaigns.templates.acquireNewCustomers.title': 'Acquire new customers',
  'campaigns.templates.acquireNewCustomers.description':
    'Acquire new customers by offering a discount.',
  'campaigns.templates.growBasketSizes.title': 'Grow basket sizes',
  'campaigns.templates.growBasketSizes.description':
    'Grow basket sizes for a collection or category by offering a discount.',
  'campaigns.templates.winBackLapsedCustomers.title': 'Win back lapsed customers',
  'campaigns.templates.winBackLapsedCustomers.description':
    'Win back lapsed customers by offering a discount.',
  'campaigns.templates.driveLoyaltyRetention.title': 'Drive loyalty retention',
  'campaigns.templates.driveLoyaltyRetention.description':
    'Increase loyalty sign-ups by offering a discount.',
  'retailerFundedMarketingDomain.campaignHeader.objective.label': 'Objective',
  'retailerFundedMarketingDomain.campaignField.name.label': 'Name',
  'retailerFundedMarketingDomain.campaignField.name.placeholder': 'Enter a campaign name',
  'retailerFundedMarketingDomain.campaignField.required.error': 'This field is required',
  'retailerFundedMarketingDomain.campaignField.name.description':
    'This name is only visible to you, and not to customers.',
  'retailerFundedMarketingDomain.campaignPlacements.title': 'What will customers see?',
  'retailerFundedMarketingDomain.campaignPlacements.description':
    'We’ll promote this campaign in pre-determined locations across marketplace.',
  'retailerFundedMarketingDomain.campaignPlacements.preview.button': 'Preview',
  'campaigns.templates.comingSoon.title': 'Coming soon',
  'campaigns.templates.comingSoon.description':
    'More campaigns to come. Share your use cases to help aid future development.',
  'retailerFundedMarketingDomain.campaignTargetingAudienceTitle.label': 'Audience',
  'retailerFundedMarketingDomain.campaignTargetingAudienceSubtitle.label':
    'This customer segment is pre-defined and cannot be changed.',
  'retailerFundedMarketingDomain.campaignTargetingLocationTitle.label': 'Location',
  'retailerFundedMarketingDomain.campaignTargetingLocationSubtitle.label':
    'Choose the locations you’d like to target for this campaign.',
  'retailerFundedMarketingDomain.campaignTargetingAudienceNewCustomersTitle.label': 'New customers',
  'retailerFundedMarketingDomain.campaignTargetingAudienceNewCustomersSubtitle.label':
    'Customers who haven’t ordered from you before.',
  'retailerFundedMarketingDomain.campaignTargetingAudienceExistingCustomersTitle.label':
    'Existing customers',
  'retailerFundedMarketingDomain.campaignTargetingAudienceExistingCustomersSubtitle.label':
    'Customers who have ordered from you before.',
  'retailerFundedMarketingDomain.campaignTargetingAudienceLapsedCustomersTitle.label':
    'Lapsed customers',
  'retailerFundedMarketingDomain.campaignTargetingAudienceLapsedCustomersSubtitle.label':
    'Re-engage customers who haven’t purchased in 28 days.',
  'retailerFundedMarketingDomain.redemptionTermsTitle.label': 'Redemption terms',
  'retailerFundedMarketingDomain.redemptionTermsDescription.label':
    'Associated promotion redemptions will stop 7 days before the end date you’ve set.',
  'retailerFundedMarketingDomain.billingOption.custom': 'Custom funding split',
  'retailerFundedMarketingDomain.billingOption.custom.description':
    'Create specific funding percentages',
  'retailerFundedMarketingDomain.billingOption.instacartFundedPercentageTitle':
    'Instacart will fund (%)',
  'retailerFundedMarketingDomain.billingOption.retailerFundedPercentageTitle':
    'Retailer will fund (%)',
  'retailerFundedMarketingDomain.create.nextButton': 'Next',
  'retailerFundedMarketingDomain.create.reviewTitle': 'Let’s review',
  'retailerFundedMarketingDomain.create.reviewDescription':
    'Almost there! Take one last look before activating your campaign.',
  'retailerFundedMarketingDomain.create.reviewSaveDescription':
    'Almost there! Take one last look before saving your campaign.',
  'retailerFundedMarketingDomain.create.editButton': 'Edit',
  'retailerFundedMarketingDomain.create.locations': 'locations',
  'retailerFundedMarketingDomain.create.all.locations': 'all locations',
  'retailerFundedMarketingDomain.create.no.locations': 'no locations',
  'retailerFundedMarketingDomain.getCampaignPage.deactivate': 'Deactivate campaign',
  'retailerFundedMarketingDomain.preview.header': 'What will customers see?',
  'retailerFundedMarketingDomain.preview.subtitle':
    'We’ll promote this campaign in pre-determined locations across marketplace.',
  'retailerFundedMarketingDomain.preview.marketplace.title': 'Instacart marketplace home',
  'retailerFundedMarketingDomain.preview.marketplace.description':
    'We’ll highlight the promotion next to your brand name.',
  'retailerFundedMarketingDomain.preview.storefront.title': 'Your brand’s page home',
  'retailerFundedMarketingDomain.preview.storefront.description':
    'We’ll display a banner across your brand’s entire storefront.',
  'retailerFundedMarketingDomain.preview.disclaimer':
    'Previews are for illustrative purposes only and are subject to change.',
  'retailerFundedMarketingDomain.activatedSuccess.header': 'Activated',
  'retailerFundedMarketingDomain.activatedSuccess.title': 'Your campaign has been activated!',
  'retailerFundedMarketingDomain.activatedSuccess.description':
    'Great Job! Now you can monitor its performance, and make adjustments accordingly. Let’s try another!',
  'retailerFundedMarketingDomain.activatedSuccess.goToCampaigns': 'Go to campaigns',
  'retailerFundedMarketingDomain.rfmCampaignDashboard.table.view.phase4': 'View (Phase 4)',
  'retailerFundedMarketingDomain.rfmCampaignDashboard.table.header.createDate': 'Created Date',
  'retailerFundedMarketingDomain.rfmCampaignDashboard.table.header.objective': 'Campaign Objective',
  'retailerFundedMarketingDomain.homeBanner.endingSoonMessage':
    '{numberOfEndingSoonCampaigns, plural, =0 {# campaign is} =1 {# campaign is} other {# campaigns are}} ending in 7 days. Extend or update the {numberOfEndingSoonCampaigns, plural, =0 {campaign} =1 {campaign} other {campaigns}} for higher return spend.',
  'retailerFundedMarketingDomain.homeBanner.bannerMessage':
    'You are running {numberOfActiveCampaigns, plural, =1 {# active campaign} other {# active campaigns}} with {numberOfEndingSoonCampaigns, plural, =1 {# campaign} other {# campaigns}} ending soon',
  'retailerFundedMarketingDomain.addCollections': 'Add collections',
  'retailerFundedMarketingDomain.createCollection': 'Create a new collection',
  'retailerFundedMarketingDomain.collection': 'Collection',
  'retailerFundedMarketingDomain.collections': 'Collections',
  'retailerFundedMarketingDomain.allProduct': 'All',
  'retailerFundedMarketingDomain.addedCollections': 'Added collections',
  'retailerFundedMarketingDomain.collection.previewButton': 'Preview',
  'retailerFundedMarketingDomain.collection.addButton': 'Add',
  'retailerFundedMarketingDomain.create.searchCollections': 'Search collections',
  'retailerFundedMarketingDomain.promotion.description':
    '{discountOff} off for orders {minimumPurchaseAmount} or more{extraMessage}.',
  'retailerFundedMarketingDomain.status.draft': 'Draft',
  'retailerFundedMarketingDomain.status.beta': 'Beta',
  'retailerFundedMarketingDomain.status.active': 'Active',
  'retailerFundedMarketingDomain.status.scheduled': 'Scheduled',
  'retailerFundedMarketingDomain.status.cancelled': 'Cancelled',
  'retailerFundedMarketingDomain.status.ended': 'Ended',
  'retailerFundedMarketingDomain.rfmCampaignDashboard.table.viewAnalytics': 'View Analytics',
  'retailerFundedMarketingDomain.discoverabilityOption.unset': 'Unset',
  'retailerFundedMarketingDomain.discoverabilityOption.unset.description': 'Unset',
  'retailerFundedMarketingDomain.discoverabilityOption.browse': 'Browse',
  'retailerFundedMarketingDomain.discoverabilityOption.browse.description':
    'Customers can find this offer through browsing.',
  'retailerFundedMarketingDomain.discoverabilityOption.directLink': 'Direct Link',
  'retailerFundedMarketingDomain.discoverabilityOption.directLink.description':
    'Customers can only find this offer through a link',
  'utm.campaign': 'Campaign',
  'utm.campaign.description': 'Campaign',
  'utm.content': 'Content',
  'utm.content.description': 'Content',
  'utm.medium': 'Medium',
  'utm.medium.description': 'Medium',
  'utm.source': 'Source',
  'utm.source.description': 'Source',
  'utm.term': 'Term',
  'utm.term.description': 'Term',
} as const

export default EN_US
